import {DOM} from '../core/dom';
import {Slider} from '../core/slider';

export namespace Benefits {
  export function onload(type: 'company' | 'freelancer', getStartedCallback: Function): void {
    Slider.setup(`${type}-benefits-slides`, type);
    DOM.onMatchClick(`.${type}-benefits-get-started-btn`, () => { getStartedCallback(); });
  }
}